import ContentRandomizer from "@/components/ContentRandomizer.vue";
export const contentRandomizerInit = {
    component: ContentRandomizer,
    name: "Content Randomizer",
    canHaveChildren: true,
    inputs: [

    ]
};
